// src/components/Loading.js
import React from 'react';
import { Spinner } from 'react-bootstrap'; // Import Spinner from React Bootstrap
import '../css/Loading.css'; // Import CSS file

const Loading = () => {
  
  return (

<>
    <div class="loading ">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>

  </div>
      <p>Please wait!!</p>
      </>
  );
};

export default Loading;
